import axios from "axios"
import { env } from '../constants'


/* The token of the administrator goes with every call */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })


/* LIST — the services of the whole platform with the filters, the numbers and the categories */
export const list = data => {
    const uri = `${env.startpoint}/admin/service/list`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* SAVE — only the fields which are sent are changed */
export const save = data => {
    const uri = `${env.startpoint}/admin/service/save`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* BULK — one category or one status for many services */
export const bulk = data => {
    const uri = `${env.startpoint}/admin/service/bulk`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* APPLY SUGGESTIONS — on the given services, or on all of them without ids */
export const applySuggestions = data => {
    const uri = `${env.startpoint}/admin/service/suggestions/apply`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}
